import {Injectable} from '@angular/core';
import {SiteContext} from '@spartacus/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from "rxjs/operators";

export const UX_TYPE_CONTEXT_ID = 'uxType';
export const UX_TYPE_APP = 'mobileApp';
export const UX_TYPE_DEFAULT = undefined;

@Injectable({providedIn: 'root'})
export class AimoUxTypeService implements SiteContext<string> {
    private activeUxType$ = new BehaviorSubject<string>(UX_TYPE_DEFAULT);

    getAll(): Observable<string[]> {
        return new BehaviorSubject([UX_TYPE_DEFAULT, UX_TYPE_APP]);
    }

    getActive(): Observable<string> {
        return this.activeUxType$.asObservable();
    }

    setActive(uxType: string): void {
        if (this.activeUxType$.getValue() !== uxType) {
            this.activeUxType$.next(uxType);
        }
    }

    isMobileApp(): Observable<boolean> {
        return this.getActive().pipe(
            map(uxType => uxType === UX_TYPE_APP)
        );
    }

    isInitialized(): boolean {
        return true;
    }
}
